import { Component, OnDestroy, OnInit } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { Subscription } from 'rxjs'
import { AppVersionsUpdateService } from './services/app-versions-update.service'

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  title: string = 'ADDboard'
  private newVersionSubscription?: Subscription;

  constructor(
    private appVersionsUpdate: AppVersionsUpdateService,
    private titleService: Title,
  ) {}

  ngOnInit() {
    this.titleService.setTitle(this.title);
    this.checkForSWUpdate();
  }

  ngOnDestroy(): void {
    this.newVersionSubscription?.unsubscribe();
  }

  checkForSWUpdate(): void {
    console.log(`APP component initialize check for appVersionsUpdate.`);
    this.newVersionSubscription?.unsubscribe();

    if (!this.appVersionsUpdate.swUpdateIsEnabled()) {
      console.log(`SwUpdate service is not enabled.`)
      return;
    }

    this.newVersionSubscription = this.appVersionsUpdate.checkForUpdate();
  }
}
